import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Tab } from 'src/app/tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/bottom-nav/tab.type';



@Component({
  selector: 'app-vertical-header',
  templateUrl: './vertical-header.component.html',
  styleUrls: ['./vertical-header.component.css']
})
export class VerticalHeaderComponent {

  /* NAV SUPERIOR ANTIGUO */
  /*
  leftMargin = '55px';
  company!: Company;
  leftText = '';
  rightText = '';
  center = false;
  centerLogoUrl = 'assets/img/Logo Vertical.svg';
  showHeader = false;

  @Output('initVerticalTour') onClickHelpVerticalEmitter = new EventEmitter<void>();
  @Output('initHorizontalTour') onClickHelpHorizontalEmitter = new EventEmitter<void>();
  @Output('sendMail') onClickSendMailEmitter = new EventEmitter<string>();


  @Input() token!: string;

  @ViewChild(InfoStudyComponent) infoModal!: InfoStudyComponent;

  locator: string = "";

  urlBook = 'Techiediaries';


  isCollapsed = true;
  showDownloadModes = false;

  bookStudies: Study[] = [];

  public Company = Company;

  downloading: { studyUID: string | null, percentage: number } | null = null //variable para descargar el informa + imágenes

  @ViewChild(ShareStudyMobileComponent) shareStudyMobileModal!: ShareStudyMobileComponent;
  @ViewChild(DownloadModalMobileComponent) downloadMobileModal!: DownloadModalMobileComponent;
  @ViewChild(HistoricalModalMobileComponent) hostoricMobileModal!: HistoricalModalMobileComponent;

  TokenPermissions = TokenPermissions;


  constructor(
    private alertService: AlertService,
    private configService: ConfigService,
    private bookService: BookService,
    private studiesService: StudiesService,
    private tourService: TourService,
    public permissionService: PermissionService,
    private globalVariables: GlobalVariables,
    private reportService: ReportService
  ) {
    this.refreshCompany();
  }

  ngOnInit(): void {

    this.studiesService.getStudiesByToken(this.token).then(sts => {
      this.bookStudies = sts;

    }).catch(error => {
      console.error(error);
    })

    this.bookService.getLocatorByToken(this.token).then(locator => {
      this.locator = locator;
    }).catch(error => {
      console.error(error);
    })
  }

  get isPageSmall() {
    return this.globalVariables.isPageSmall;
  }

  get isPageVertical() {
    return window.innerHeight > window.innerWidth;
  }

  refreshCompany() {
    this.company = this.configService.company;
    if (this.company == Company.NOT_DEFINED) {
      setTimeout(() => {
        this.refreshCompany();
      }, 200);
    }
  }

  onClickDownloadModal() {
    this.downloadMobileModal.openModal();
  }

  onClickSharedModal() {
    this.shareStudyMobileModal.openModal(this.locator);
  }

  initTour() {
    this.tourService.initMobileTour();
    if (this.isPageSmall && this.isPageVertical) {
      this.onClickHelpVerticalEmitter.emit();
      
    } else {     
      this.onClickHelpHorizontalEmitter.emit();
    }

    this.isCollapsed = true;
  }

  sendMail(mail: string) {
    this.onClickSendMailEmitter.emit(mail);
    
  }


  showInfoModal() {
    this.infoModal.openModal(this.locator, this.bookStudies);
  }

  downloadReport() {
    this.reportService.downloadReports(this.bookService.currentBook!.studyUIDs[0]);
  }

  downloadStudy() {
    let studyUIDs: string[] = [];

    studyUIDs = this.bookStudies.map(st => st.studyUID!);

    if (studyUIDs.length == 0) {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }
    this.downloadStudies(studyUIDs);
  }

  downloadStudies(studyUIDs: string[]) {
    if (this.downloading == null) {
      this.downloading = { studyUID: (studyUIDs.length == 1) ? studyUIDs[0] : null, percentage: 0 }
      setTimeout(() => {
        if (environment.demo) {
          const interval = setInterval(() => {
            if (++this.downloading!.percentage == 100) {
              clearInterval(interval);
              this.downloading = null;
            }
          }, 75)
        } else {
          let startedDownloading = false;
          const randomIntFromInterval = (min: any, max: any) => { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
          }
          const interval = setInterval(() => {
            if (startedDownloading) {
              clearInterval(interval);
            } else {
              if (this.downloading!.percentage < 10) {
                this.downloading!.percentage += (randomIntFromInterval(0, 30) / 100) // ~ 1m 15s
              } else if (this.downloading!.percentage < 20) {
                this.downloading!.percentage += (randomIntFromInterval(10, 30) / 100) // ~ 1m
              } else if (this.downloading!.percentage < 30) {
                this.downloading!.percentage += (randomIntFromInterval(10, 50) / 100) // ~ 35s
              } else if (this.downloading!.percentage < 35) {
                this.downloading!.percentage += (randomIntFromInterval(0, 10) / 100) // ~ 1m 50s
              } else if (this.downloading!.percentage < 50) {
                this.downloading!.percentage += (randomIntFromInterval(0, 7) / 100) // ~ 8m
              }
            }
          }, 1200);
          this.studiesService.downloadStudies(studyUIDs).subscribe(event => {
            if (event!.type == HttpEventType.DownloadProgress) {
              startedDownloading = true;
              const percentage = ((event!.loaded / event!.total!) * 50) + 50
              console.log('percentage: ', percentage);
              this.downloading!.percentage = Math.round(percentage)
            }
            if (event!.type == HttpEventType.Response) {
              const link = document.createElement('a');
              if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(event!.body!);
                link.setAttribute('href', url);
                link.setAttribute('download', "dicomdir.zip");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
              this.downloading = null;
            }
          })
        }
      }, 1);
    } else {
      this.alertService.alert('Ya se está descargando un estudio. Por favor, espere a que finalice')
    }
  }


  onClickDownloadInstructions(b: PatientHistoryEntry) {
    if (b.bookId == null) {
      this.alertService.alert('Error: Se ha producido un error a la hora de obtener el book');
    } else {
      this.bookService.downloadInstructions(b.bookId).then(res => {
        if (res != null) {
          const blob = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobUrl;
          a.download = 'instructions_' + b.bookId + '.pdf';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        } else {
          this.alertService.alert('Error: No se ha podido descargar el informe');
        }
      }).catch(err => {
        this.alertService.alert("Se ha producido un error descargando las instrucciones para este estudio");
        console.error(err)
      })
    }
  }

  startBasicTour(){
    {
      const steps = [
        
        {
          id: "btn-1",
          attachTo: {
            element: '#headerToggler > div:nth-child(5)',
            on: 'bottom',
          },
          buttons: [
            {
              classes: 'tour-round-button',
              text: "Finalizar",
              action: () => {
                this.isCollapsed = true;
                this.tourService.guideTour.complete();
              }
            }
          ],
          text: "<p>Pulsando este botón se iniciará el Tour de la aplicación</p>",
        }
      ];
      this.tourService.guideTour.addSteps(steps);
      this.tourService.guideTour.start();
    }
  }

  addVerticalMenuSteps() {
    const steps = [
      {
        id: "btn-4",
        attachTo: {
          element: '#headerToggler > div:nth-child(2)',
          on: 'bottom',
        },

        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(0, 0);
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.isCollapsed = true;
              (document.getElementById('bookSwiper') as any)?.swiper?.slideTo(2, 0);
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: this.tourService.guideTour.next,
          }
        ],
        text: "<p>Pulsando ese botón se mostrarán las opciones de descarga</p>",

      },
      {
        id: "btn-5",
        attachTo: {
          element: '#headerToggler > div:nth-child(3)',
          on: 'bottom',
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: this.tourService.guideTour.back,
          },
          {
            classes: 'tour-round-button',
            text: "Finalizar",
            action: () => {
              this.isCollapsed = true;
              this.tourService.guideTour.complete();
            }
          }
        ],
        text: "<p>Pulsando ese botón se mostrán las opciones para compartir el Book</p>",
      }
    ];

    this.tourService.guideTour.addSteps(steps);
  }

  addHorizontalMenuSteps() {
    const steps = [
      {
        id: "btn-3",
        attachTo: {
          element: '#headerToggler > div:nth-child(2)',
          on: 'right',
        },

        buttons: [
          {
            classes: 'tour-round-button',
            text: "Omitir",
            action: () => {
              this.tourService.guideTour.cancel();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: () => {
              this.isCollapsed = true;
              ($("#flipbook") as any).turn("page", 2);
              this.tourService.guideTour.back();
            }
          },
          {
            classes: 'tour-round-button',
            text: "Siguiente",
            action: this.tourService.guideTour.next,
          }
        ],
        text: "<p>Pulsando ese botón se mostrarán las opciones de descarga</p>",

      },
      {
        id: "btn-4",
        attachTo: {
          element: '#headerToggler > div:nth-child(3)',
          on: 'right',
        },
        buttons: [
          {
            classes: 'tour-round-button',
            text: "Atrás",
            action: this.tourService.guideTour.back,
          },
          {
            classes: 'tour-round-button',
            text: "Finalizar",
            action: () => {
              this.isCollapsed = true;
              this.tourService.deleteAllSteps(this.tourService.guideTour.steps.length);
              this.tourService.guideTour.complete();
            }
          }
        ],
        text: "<p>Pulsando ese botón se mostrán las opciones para compartir el Book</p>",
      }
    ];

    this.tourService.guideTour.addSteps(steps);
  }

  showHistoricModal() {
    this.hostoricMobileModal.openModal();
  }

  */

  @Output() menuClick = new EventEmitter<void>();

  @Output('onClickViewer') onClickViewerEmitter = new EventEmitter<void>();

  
}